import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function ProtectedRoute({ children, requiredPermission = null }) {
  const { isAuthenticated, can, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-psg-teal" />
      </div>
    )
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (requiredPermission) {
    const s = requiredPermission
    const i = s.lastIndexOf(':')
    const resource = i > 0 ? s.slice(0, i) : s
    const action = i > 0 ? s.slice(i + 1) : 'view'
    if (!can(resource, action)) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
          <p className="text-gray-700">You do not have access to this page.</p>
        </div>
      )
    }
  }

  return children
}
